import { render, staticRenderFns } from "./BtnProgress.vue?vue&type=template&id=aed15040"
import script from "./BtnProgress.vue?vue&type=script&lang=js"
export * from "./BtnProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports